import React from 'react';
import { Modal } from 'react-bootstrap';

import Button from 'components/DesignSystem/Button';
import Icon from 'components/DesignSystem/Icon';
import { useDeleteVideoMutation } from 'services/api/videos';
import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import {
  VideoProduct,
  videoProductToPath,
  videoProductToPermission,
} from 'helper/videos';
import { CANCELLED } from 'constants/colors';

// Aceita qualquer vídeo com id + título (VideosGetLast na lista, VideoData no player).
export interface DeletableVideo {
  id: number;
  titulo: string;
}

export default function DeleteDialog({
  video,
  product,
  dismiss,
  onDeleted,
}: {
  video: DeletableVideo | null;
  product: VideoProduct;
  dismiss: () => void;
  onDeleted: (message: string) => void;
}) {
  const [deleteVideo, { error, isLoading }] = useDeleteVideoMutation();
  useHandleRequestErrors(error as ResponseError | undefined);

  const confirmDelete = async () => {
    if (!video) return;
    const result = await deleteVideo({
      id: video.id,
      productPath: videoProductToPath[product],
      permissionType: videoProductToPermission[product],
    });
    if (!('error' in result)) {
      onDeleted('Vídeo excluído');
    }
  };

  return (
    <Modal
      show={video !== null}
      onHide={dismiss}
      centered
      contentClassName="videos-mobile-delete"
    >
      <span className="videos-mobile-delete-icon">
        <Icon iconType="trash" color={CANCELLED} size="large" />
      </span>
      <h2 className="videos-mobile-delete-title">Excluir vídeo?</h2>
      <p className="videos-mobile-delete-text">
        {video?.titulo}
        {' '}
        será removido permanentemente.
      </p>
      <div className="videos-mobile-delete-actions">
        <Button type="secondary" className="flex-fill" onClick={dismiss}>
          Cancelar
        </Button>
        <Button
          className="flex-fill videos-mobile-delete-confirm"
          disabled={isLoading}
          onClick={confirmDelete}
        >
          Excluir
        </Button>
      </div>
    </Modal>
  );
}
